import React from 'react';

import { createDashboardTableClassName } from './dashboardTableStyles';

export const DashboardTableColumn: React.FC = ({ children }) => (
  <div className={createDashboardTableClassName('column')}>{children}</div>
);
